function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeater({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.655943,
    height: 177.30005,
    viewBox: "0 0 30.655943 177.30006",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(-363.42999,-529.34997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "m 376.95999,529.76001 v 176.64001 l -13.28,-0.16003 V 529.59998",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    d: "M 122.06801,0.01386691 H 93.17482 V -183.59767 c -6.834947,6.67961 -15.99999,13.28155 -27.339789,19.88348 -11.184459,6.67961 -21.28154,11.65048 -30.135904,14.91262 v -27.96115 c 16.15533,-7.45631 30.213574,-16.54368 42.252401,-27.33979 11.961158,-10.71844 20.504842,-21.20387 25.475712,-31.37862 h 18.64077 z m 91.26208,0 V -32.918151 h 32.62133 V 0.01386691 Z m 72.31063,-61.51452491 30.1359,-2.485435 c 2.25243,14.757272 7.45631,25.786391 15.53397,33.242697 8.23301,7.456307 18.09708,11.18446 29.51455,11.18446 13.82523,0 25.55338,-5.126211 35.10677,-15.533971 9.70874,-10.563101 14.60194,-24.543674 14.60194,-41.941722 0,-16.310669 -4.6602,-29.281531 -13.98058,-38.834931 -9.16504,-9.47572 -21.1262,-14.29125 -36.03881,-14.29125 -9.32038,0 -17.70873,2.17476 -25.16503,6.52427 -7.45631,4.19417 -13.35922,9.55339 -17.70873,16.15533 l -27.02911,-3.41748 22.6796,-120.54361 h 116.81546 v 27.65047 h -93.51451 l -12.73785,63.06792 c 14.05824,-9.94174 28.89318,-14.91261 44.42716,-14.91261 20.50484,0 37.66987,7.14562 51.57278,21.43688 14.05824,14.13591 21.1262,32.31066 21.1262,54.679576 0,21.1262 -6.13592,39.456286 -18.33009,54.990257 -15.14562,19.1067841 -35.72813,28.5825064 -61.8252,28.5825064 -21.35921,0 -38.75726,-5.9805789 -52.19414,-18.0194064 -13.51456,-11.961158 -21.1262,-27.805808 -22.99028,-47.533951 z M 477.25225,0.01386691 V -234.54909 h 28.89319 v 133.59215 l 68.03879,-68.97084 h 37.28153 l -64.932,63.06793 71.45627,106.87371691 H 582.57257 L 526.3396,-86.97637 506.14544,-67.403567 V 0.01386691 Z m 204.97075,0 L 620.08711,-234.54909 h 31.6893 l 35.72814,153.786308 c 3.88349,16.15533 7.22329,32.15532 9.94174,47.844631 5.98058,-25.009694 9.47572,-39.456287 10.5631,-43.18444 l 44.73784,-158.446499 h 37.28153 l 33.86405,118.67953 c 8.23301,29.436879 14.29126,57.087347 18.01941,82.951409 3.10679,-14.679603 6.99029,-31.689301 11.80582,-50.951425 l 36.66017,-150.679514 h 31.37862 L 857.44619,0.01386691 h -30.1359 L 777.91226,-178.6268 c -4.19417,-15.06795 -6.52427,-24.31066 -7.14563,-27.65047 -2.48543,10.79611 -4.8932,20.03883 -7.14562,27.65047 L 713.9123,0.01386691 Z m 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0,0.050293,-0.050293,0,382.24288,595.8413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M 0,0 13.28,0.16 M 0,5.12 13.28,5.28 M 0,10.24 13.28,10.4 M 0,15.52 H 13.28 M 0,20.639999 H 13.28 M 0,25.76 13.28,25.92 M 0,30.879999 13.28,31.040001 M 0,36 13.28,36.16 M 0,41.279999 H 13.28 M 0,46.400002 13.28,46.560001 M 0,51.52 13.28,51.68 M 0,56.639999 l 13.28,0.16 M 0,61.919998 H 13.28 M 0,67.040001 H 13.28 M 0,72.160004 13.28,72.32 M 0,77.279999 13.28,77.440002 m -13.28,4.96 13.28,0.159996 M 0,87.68 H 13.28 M 0,92.800003 H 13.28 M 0,97.919998 13.28,98.080002 M 0,103.04 13.28,103.2 M 0,108.16 13.28,108.32 M 0,113.44 H 13.28 M 0,118.56 H 13.28 M 0,123.68 13.28,123.84 M 0,128.8 13.28,128.96001 M 0,133.92 13.28,134.08 M 0,139.2 H 13.28 M 0,144.32001 13.28,144.48 M 0,149.44 13.28,149.60001 M 0,154.56 13.28,154.72 M 0,159.84 H 13.28 M 0,164.96001 H 13.28 M 0,170.08 13.28,170.24 M 0,175.2 l 13.28,0.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(363.67999,529.59997)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeater);
export default __webpack_public_path__ + "static/media/heater.83e74372a01b92044202e2507e243394.svg";
export { ForwardRef as ReactComponent };